import { createSlice } from "@reduxjs/toolkit";

export const initialScheduleForm ={
    full_name:"",
    email_address:"",
    mobile_number:"",
    description:""
}

export const initialDownloadForm = {
  mobile_number : ""
}

const publicSlice = createSlice({
    name:"publicSlice",
    initialState:{
      form:{
        scheduleCallForm:initialScheduleForm,
        addDownloadComponent : 1,
        downloadForm:initialDownloadForm
      },
      popup:{
        scheduleCallPopup:false,
        addDownloadPlanPopup:false
      },
      other:{
        search:"",
        page:1,
        category:null
      }
    },
    reducers:{
      // other state reducer
      addSearch:(state, action)=>{
        state.other.search=action.payload
      },
      addPage:(state, action)=>{
        state.other.page=action.payload
      },
      addCategory:(state, action)=>{
        state.other.category=action.payload
      },
    
      // form state reducer  
      addScheduleCallForm:(state,action)=>{
        state.form.scheduleCallForm=action.payload
      },
      addDownloadComponent:(state,action)=>{
        state.form.addDownloadComponent=action.payload
      },
      openDownloadPopup:(state)=>{
        state.popup.addDownloadPlanPopup=true
      },
      closeDownloadPopup:(state)=>{
        state.popup.addDownloadPlanPopup=false
      },
      addDownloadForm:(state,action)=>{
        state.form.downloadForm=action.payload
      }
    }
})

export const {addScheduleCallForm, addCategory, addPage, addSearch, addDownloadComponent, openDownloadPopup, closeDownloadPopup, addDownloadForm}=publicSlice.actions

// get form state
export const getScheduleForm = (state) => state.public.form.scheduleCallForm
export const getAddDownloadPlanPopup = (state) => state.public.popup.addDownloadPlanPopup
export const getAddDownloadComponent = (state) => state.public.form.addDownloadComponent
export const getDownloadForm = (state) => state.public.form.downloadForm
// get other state
export const getSearch = (state) => state.public.other.search
export const getPage = (state) => state.public.other.page
export const getCategory = (state) => state.public.other.category


export default publicSlice.reducer

